import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useResolvedUrl, parseUrlScheme } from './useResolvedUrl';
import { CodeBlockPlaceholder } from './CodeBlockPlaceholder';
/**
 * Markdown figure component for images with captions.
 * Wraps the image in a <figure> element with a <figcaption>.
 *
 * Usage in markdown: ![alt text](image-url "Caption text")
 */
export function MarkdownFigure({ src, alt, caption, className, artifactRunId, }) {
    const rawSrc = src || '';
    const { scheme } = parseUrlScheme(rawSrc);
    // For standard URLs, render directly
    if (scheme === 'standard') {
        return (_jsxs("figure", { className: "my-4", children: [_jsx("img", { src: src, alt: alt, className: className }), _jsx("figcaption", { className: "mt-2 text-sm text-muted text-center italic", children: caption })] }));
    }
    // For artifact: and image: URLs, use the resolver
    return (_jsx(ResolvedFigure, { rawSrc: rawSrc, alt: alt, caption: caption, artifactRunId: artifactRunId, className: className }));
}
/**
 * Internal component for figures that need async URL resolution
 */
function ResolvedFigure({ rawSrc, alt, caption, artifactRunId, className, }) {
    const { url, isLoading, error, retry } = useResolvedUrl({
        rawUrl: rawSrc,
        artifactRunId,
        disposition: 'inline',
    });
    if (isLoading) {
        return _jsx(CodeBlockPlaceholder, { type: "image", message: alt ? `Loading ${alt}...` : undefined });
    }
    if (error) {
        return (_jsx(CodeBlockPlaceholder, { type: "image", error: error, onRetry: retry }));
    }
    if (!url) {
        return null;
    }
    return (_jsxs("figure", { className: "my-4", children: [_jsx("img", { src: url, alt: alt, className: className }), _jsx("figcaption", { className: "mt-2 text-sm text-muted text-center italic", children: caption })] }));
}
//# sourceMappingURL=MarkdownFigure.js.map